import { BACKEND_URL } from '../config'
import Model from './model'
import Address from './address'

class Hub extends Model {
  static get name() {
    return 'hubs'
  }

  static get url() {
    return `${BACKEND_URL}/infrastructure/hubs`
  }

  static get parsers() {
    return {
      ...Model.parsers,
      address: dataDict => Address.one(dataDict)
    }
  }

  get string() {
    return this.cityName
  }

  get cityName() {
    return this.address ? this.address.locality : undefined
  }
}

export default Hub
